import { useEffect, useState } from "react";

import { resolveConsigneeEntityLabel } from "@/lib/clientPortalDisplay";

/** Entity display label for a Client user's linked consignee (canonical code). */
export function useClientConsigneeDisplayLabel(
  consigneeLink: string | null | undefined,
  enabled: boolean,
): string | null {
  const [label, setLabel] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !consigneeLink?.trim()) {
      setLabel(null);
      return;
    }
    let cancelled = false;
    void resolveConsigneeEntityLabel(consigneeLink).then((next) => {
      if (!cancelled) setLabel(next);
    });
    return () => {
      cancelled = true;
    };
  }, [consigneeLink, enabled]);

  return label;
}
